{
  "pt": {
    "toast": {
      "action": {
        "email_address_taken": "Este endereço de e-mail já pertence a outro contacto.",
        "failed": "Ocorreu um erro inesperado.",
        "impersonate_unauthorized": "Esta ação não é permitida quando se faz passar por um cliente.",
        "storage_quota_exceeded": "Limite de armazenamento atingido. Elimine ficheiros ou contacte-nos para atualizar o seu plano.",
        "succeeded": "Ação bem sucedida",
        "task_assignment_document_required": "Esta tarefa precisa de pelo menos um documento antes de poder ser concluída.",
        "unprocessable": "Algo correu mal. Talvez queira atualizar a página. Se o problema persistir, contacte-nos.\nERRO: {error}"
      },
      "create": {
        "failed": "Falha ao criar {itemName}",
        "succeeded": "{itemName} criado"
      },
      "delete": {
        "failed": "Falha ao eliminar {itemName}",
        "succeeded": "{itemName} foi eliminado",
        "succeeded_default": "Eliminação bem sucedida"
      },
      "support_chat": {
        "unavailable": "O chat não está disponível aqui. Envie-nos um e-mail para {email_address} e ajudá-lo-emos."
      },
      "update": {
        "failed": "Falha ao atualizar {itemName}",
        "succeeded": "{itemName} foi atualizado",
        "successfully_saved": "Guardado com sucesso"
      },
      "upload": {
        "failed": "O carregamento falhou",
        "succeeded": "Carregamento bem sucedido"
      },
      "upload_document": {
        "extension_invalid": "O documento \"{document_name}\" não tem uma extensão válida."
      },
      "upload_image": {
        "file_too_big": "Ficheiro demasiado grande: o tamanho máximo do ficheiro é de 5MB"
      },
      "warning": {
        "multipleFiles": "Esta exportação contém vários ficheiros zip. O seu navegador pode bloquear vários descarregamentos. Contacte o apoio Ziggu se tiver apenas 1 ficheiro zip descarregado."
      }
    }
  }
}
